import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DeleteOutlined, DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Table, Popconfirm
} from 'antd';
import 'moment/locale/zh-cn';
import cookie from "react-cookies";
const { Title,Text } = Typography;
const { Content } = Layout;

const DecimalStep = () => {
    const [inputValue, setInputValue] = useState(0);
    const onChange = (value) => {
        if (isNaN(value)) {
            return;
        }
        setInputValue(value);
    };
    return (
        <Row>
            <Col span={12}>
                <Slider
                    min={0}
                    max={10}
                    onChange={onChange}
                    value={typeof inputValue === 'number' ? inputValue : 0}
                    step={0.01}
                />
            </Col>
            <Col span={4}>
                <InputNumber
                    min={0}
                    max={10}
                    style={{
                        margin: '0 16px',
                    }}
                    step={0.01}
                    value={inputValue}
                    onChange={onChange}
                />
            </Col>
        </Row>
    );
};
const onChange = (date, dateString) => {
    console.log(date, dateString);
};
const onGo = () => {
    window.location.href="/pagebuildassayed"
};
const Delete = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellassaystate?state=0&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <Popconfirm
            title="删除后将不可恢复"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button  onClick={showPopconfirm}>
                删除
            </Button>
        </Popconfirm>
    );
};
const columns = [
    {
        title: '序号',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: '编号',
        dataIndex: 'assay_num',
        key: 'assay_num',
    },
    {
        title: '品名',
        dataIndex: 'stocktype_name',
        key: 'stocktype_name',
    },
    {
        title: '密度',
        dataIndex: 'assay_gcm3',
        key: 'assay_gcm3'
    },
    {
        title: '比表面积',
        dataIndex: 'assay_m2kg',
        key: 'assay_m2kg'
    },
    {
        title: '活性指数(7d)',
        dataIndex: 'assay_7d',
        key: 'assay_7d'
    },
    {
        title: '活性指数(28d)',
        dataIndex: 'assay_28d',
        key: 'assay_28d'
    },
    {
        title: '流动度比',
        dataIndex: 'assay_F',
        key: 'assay_F'
    },
    {
        title: '氧化镁含量',
        dataIndex: 'assay_mgo',
        key: 'assay_mgo'
    },
    {
        title: '需水量比',
        dataIndex: 'assay_h2o',
        key: 'assay_h2o'
    },
    {
        title: '三氧化硫',
        dataIndex: 'assay_so3',
        key: 'assay_so3'
    },
    {
        title: '氯离子',
        dataIndex: 'assay_cl',
        key: 'assay_cl'
    },
    {
        title: '烧失量',
        dataIndex: 'assay_loi',
        key: 'assay_loi'
    },
    {
        title: '碱含量',
        dataIndex: 'assay_na2o',
        key: 'assay_na2o'
    },
    {
        title: '检验日期',
        dataIndex: 'assay_date',
        key: 'assay_date',
    },
    {
        title: '发布日期',
        dataIndex: 'assay_pubtime',
        key: 'assay_pubtime',
    },
    {
        title: '功能',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Delete id={record.assay_id}></Delete>
            </Space>
        ),
    },
];

class PageBuildAssayr extends Component{


    constructor(props) {
        super(props);
        const userid = cookie.load('userId');
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        this.state = {
            title: "化验报告",
            county: [],
            userid: userid,
            id: id,
            list: {},
            admin: {}
        };
    }

    componentDidMount() {
        const id = this.state.id;
        if(id){
            fetch("https://pd.pokemonbye.com:8084/api/getsellbuildassaybydate?date=" + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        console.log(array)
                        if(array!=null&&array.length>0){

                            this.setState({
                                isLoaded: true,
                                list: array[0]
                            });
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
        fetch("https://pd.pokemonbye.com:8084/api/getsellsysdata")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if (array != null && array.length > 0) {
                        for (let i = 0; i < array.length; i++) {
                            array[i].key = i + 1
                        }
                        this.setState({
                            isLoaded: true,
                            admin: array[0]
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        return (
            <div>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <div
                                style={{
                                    backgroundColor: '#FFFFFF'
                                }}>

                                <PageHeader
                                    ghost={false}
                                    title={this.state.title}
                                    style={{
                                        backgroundColor: '#00000000'
                                    }}
                                >
                                    <div className="background-seal2"></div>
                                    <div>
                                        <Descriptions
                                            title={this.state.admin.sysdata_name}
                                            bordered
                                            column={{
                                                xxl: 4,
                                                xl: 3,
                                                lg: 3,
                                                md: 3,
                                                sm: 2,
                                                xs: 1,
                                            }}
                                        >
                                            <Descriptions.Item label="品名" span={2}>{this.state.list.stocktype_name}</Descriptions.Item>
                                            <Descriptions.Item label="出厂编号" span={2}>{this.state.list.assay_num}</Descriptions.Item>
                                            <Descriptions.Item label="取样地点" span={2}>{this.state.admin.sysdata_name}</Descriptions.Item>
                                            <Descriptions.Item label="检测日期" span={2}>{this.state.list.assay_date}</Descriptions.Item>
                                            <Descriptions.Item label="细度(质量分数)/%≥" span={2}>{this.state.list.assay_F}</Descriptions.Item>
                                            <Descriptions.Item label="需水量比(质量分数)/%≤" span={2}>{this.state.list.assay_h2o}</Descriptions.Item>
                                            <Descriptions.Item label="三氧化硫(质量分数)/%≤" span={2}>{this.state.list.assay_so3}</Descriptions.Item>
                                            <Descriptions.Item label="游离氧化钙(质量分数)/%≤" span={2}>{this.state.list.assay_cl}</Descriptions.Item>
                                            <Descriptions.Item label="烧失量(质量分数)/%≤" span={2}>{this.state.list.assay_loi}</Descriptions.Item>
                                            <Descriptions.Item label="强度活性指数(质量分数)/%≤" span={2}>{this.state.list.assay_na2o === '0.0' ? "/" : this.state.list.assay_na2o}</Descriptions.Item>
                                        </Descriptions>
                                        <Descriptions
                                            title=" "
                                        >
                                            <Descriptions.Item label="检验员" span={2}>品控室</Descriptions.Item>{/*
                                            <Descriptions.Item label="审核" span={2}>品控室</Descriptions.Item>*/}
                                        </Descriptions>
                                    </div>

                                </PageHeader>
                            </div>
                        </div>
                    </Content>
            </div>
        );
    }
}

export default PageBuildAssayr;


